/**
 * GeChiUI dependencies
 */
import { SVG, Path } from '@gechiui/primitives';

const alignLeft = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 19.8h8.9v-1.5H4v1.5zm8.9-15.6H4v1.5h8.9V4.2zm-8.9 7v1.5h16v-1.5H4z" />
	</SVG>
);

export default alignLeft;
